import React from 'react';
import { EMPTY } from 'rxjs';
import { defineMessages, FormattedMessage } from 'react-intl';

import { DocumentType } from '../../../enums/document-type';

const messages = defineMessages({
  downloadOrderSummaryStartedTitle: {
    description: 'printEpics.downloadOrderSummaryStartedTitle',
    defaultMessage: 'Downloading Order Summary',
    id: 'oHoLbf',
  },
  downloadOrderSummaryStartedContent: {
    description: 'printEpics.downloadOrderSummaryStartedContent',
    defaultMessage: 'Order Summary Download Started',
    id: 'L3EyQQ',
  },
  downloadOrderSummaryCompletedTitle: {
    description: 'printEpics.downloadOrderSummaryCompletedTitle',
    defaultMessage: 'Downloading Order Summary...',
    id: 'Rtp46+',
  },
  downloadOrderSummaryCompletedContent: {
    description: 'printEpics.downloadOrderSummaryCompletedContent',
    defaultMessage: 'Order Summary Download Completed.',
    id: 'xhHCMP',
  },
  printingOrderSummarySuccessTitle: {
    description: 'printEpics.printingOrderSummarySuccessTitle',
    defaultMessage: 'Printing Order Summary...',
    id: 'kbh9c0',
  },
  printingOrderSummarySuccessContent: {
    description: 'printEpics.printingOrderSummarySuccessContent',
    defaultMessage: 'Order Summary sent to {printerName}.',
    id: 'vC6vm9',
  },
});

export const orderSummary = {
  id: DocumentType.OrderSummary.identifier,

  getDownloadStartedProps: () => ({
    title: <FormattedMessage {...messages.downloadOrderSummaryStartedTitle} />,
    content: <FormattedMessage {...messages.downloadOrderSummaryStartedContent} />,
  }),

  getDownloadCompletedProps: () => ({
    title: <FormattedMessage {...messages.downloadOrderSummaryCompletedTitle} />,
    content: <FormattedMessage {...messages.downloadOrderSummaryCompletedContent} />,
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: <FormattedMessage {...messages.printingOrderSummarySuccessTitle} />,
    content: <FormattedMessage {...messages.printingOrderSummarySuccessContent} values={{ docCount, printerName }} />,
  }),

  getPrintedSuccessObservable: () => {
    return EMPTY;
  },
};
